import React, { createContext, useContext, useState } from "react";

const ContactDrawerContext = createContext();

export function ContactDrawerProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = () => setIsOpen(true);
  const closeDrawer = () => setIsOpen(false);

  return (
    <ContactDrawerContext.Provider value={{ isOpen, openDrawer, closeDrawer }}>
      {children}
    </ContactDrawerContext.Provider>
  );
}

export function useContactDrawer() {
  const context = useContext(ContactDrawerContext);
  if (context === undefined) {
    throw new Error("useContactDrawer must be used within a ContactDrawerProvider");
  }
  return context;
}
